export const defaultFieldSetting = {
	freezeStart: true,
	freezeEnd: true,
	start: [
		{
			fieldId: "emp.empNoAndName",
			checked: true,
		},
		{
			fieldId: "emp.jobId",
			checked: true,
		},
		{
			fieldId: "workHourInfo.workHour",
			checked: true
		},
		{
			fieldId: "totalHours",
			checked: true,
		},
		{
			fieldId: "cardHours",
			checked: true,
		},
		{
			fieldId: "emp.empNo",
		},
		{
			fieldId: "emp.name",
		},
		{
			fieldId: "emp.enName",
		},

		{
			fieldId: "emp.deptId",
		},

	],
	end: [
		{
			fieldId: "workHourInfo.leave3",
		},
		{
			fieldId: "workHourInfo.leave4",
		},
		{
			fieldId: "workHourInfo.leave2",
		},
		{
			fieldId: "workHourDiff",
		},
		{
			fieldId: "workHourInfo.leave1",
		},
		{
			fieldId: "workHourInfo.leave5",
		},
		{
			fieldId: "specialRest",
		},
		{
			fieldId: "compTime",
		},
	],
};

export const fieldIdMap = {
	"emp.empNo": { name: OptionUtils.getLabel('global.normal', 'employeeNumber'), fieldIdSortKey: "emp.empNo", withOut: ["emp.empNoAndName"] },
	"emp.name": { name: OptionUtils.getLabel('global.normal', 'name'), fieldIdSortKey: "emp.name", withOut: ["emp.empNoAndName"] },
	"emp.empNoAndName": {
		name: OptionUtils.getLabel('h2.am.ShiftingConstants', 'nameStaff'),
		fieldIdSortKey: "emp.empNo",
		withOut: ["emp.name", "emp.empNo"]
	},
	"emp.enName": { name: OptionUtils.getLabel('hp.m3.m310080', 'englishName'), fieldIdSortKey: "emp.enName" },
	"emp.jobId": { name: OptionUtils.getLabel('components.EmpUtils', 'posts'), fieldIdSortKey: "emp.jobSortOrder" },
	"emp.deptId": { name: OptionUtils.getLabel('global.normal', 'dept'), fieldIdSortKey: "emp.deptId" },
	totalHours: { name: OptionUtils.getLabel('components.EmpUtils', 'scheduledHours'), fieldIdSortKey: "totalHours", disable: true },
	specialRest: { name: OptionUtils.getLabel('h2.am.ShiftingConstants', 'remainingSpecialHolidayHours'), fieldIdSortKey: "emp.specialRest" },
	compTime: { name: OptionUtils.getLabel('h2.am.ShiftingConstants', 'remainingCompensatoryTimeOffHours'), fieldIdSortKey: "emp.compTime" },
	cardHours: { name: OptionUtils.getLabel('h2.am.ShiftingConstants', 'actualCreditCardSwipingManHours'), fieldIdSortKey: "emp.cardHours" },
	"workHourInfo.workHour": { name: OptionUtils.getLabel('h2.am.ShiftingConstants', 'hoursShouldBeScheduled'), fieldIdSortKey: "emp.workHourInfo.workHour" },
	workHourDiff: {
		name: OptionUtils.getLabel('h2.am.ShiftingConstants', 'differentialWork'),
		fieldIdSortKey: "workHourDiff",
		tip: OptionUtils.getLabel('h2.am.ShiftingConstants', 'linedShouldBeArranged')
	},
	"workHourInfo.leave1": {
		name: OptionUtils.getLabel('h2.am.ShiftingConstants', 'workingDaysShouldBeScheduled'),
		fieldIdSortKey: "emp.workHourInfo.leave1"
	},
	"workHourInfo.leave2": {
		name: OptionUtils.getLabel('h2.am.ShiftingConstants', 'nationalHolidaysShouldBeScheduled'),
		fieldIdSortKey: "emp.workHourInfo.leave2"
	},
	"workHourInfo.leave3": {
		name: OptionUtils.getLabel('h2.am.ShiftingConstants', 'restDaysShouldBeScheduled'),
		fieldIdSortKey: "emp.workHourInfo.leave3"
	},
	"workHourInfo.leave4": {
		name: OptionUtils.getLabel('h2.am.ShiftingConstants', 'holidaysShouldBeScheduled'),
		fieldIdSortKey: "emp.workHourInfo.leave4"
	},
	"workHourInfo.leave5": {
		name: OptionUtils.getLabel('h2.am.ShiftingConstants', 'shiftsShouldBeEmptied'),
		fieldIdSortKey: "emp.workHourInfo.leave5"
	}
};
